import { classes } from './comments-header.st.css';
/*
  Desktop layout:

    "areaA empty"
    "areaB areaC"

  Mobile layout:

    "areaA areaB"
    "areaC empty"

  If only two elements are rendered, we switch to one row layout for both mobile and desktop:

    "areaA areaB"
*/
export const resolveElementAreaClasses = ({ isMobile, isTitleVisible, isRatingVisible, isUserAuthVisible, }) => {
    if (isMobile) {
        return {
            titleArea: classes.areaA,
            ratingArea: !isTitleVisible
                ? classes.areaA
                : isUserAuthVisible
                    ? classes.areaC
                    : classes.areaB,
        };
    }
    else {
        return {
            titleArea: classes.areaA,
            ratingArea: !isTitleVisible ? classes.areaA : classes.areaB,
            userAuthArea: isTitleVisible && isRatingVisible ? classes.areaC : classes.areaB,
        };
    }
};
// As we need the header visibility inside rootBox this can not become a part of component - it
// has to be resolved higher up the component tree
export const resolveHeaderVisibility = ({ hideHeader, hideTitle, hideRatings, userAuthControlState, }) => hideHeader || (hideTitle && hideRatings && userAuthControlState.type === 'HIDDEN')
    ? { type: 'HIDDEN' }
    : {
        type: 'VISIBLE',
        visibilityProps: {
            userAuthControlState,
            hideTitle: !!hideTitle,
            hideRatings: !!hideRatings,
        },
    };
export const resolveUserAuthControlState = (displayConfig = 'LOGOUT_ONLY', currentMember) => {
    var _a;
    if (currentMember) {
        return { type: 'LOGOUT', memberAvatarUrl: (_a = currentMember.profile.photo) === null || _a === void 0 ? void 0 : _a.url };
    }
    return displayConfig === 'LOGOUT_ONLY' ? { type: 'HIDDEN' } : { type: 'LOGIN' };
};
//# sourceMappingURL=comments-header-utils.js.map